import {
  CARD_SPACING,
  SUBCARD_SPACING,
} from "@packages/design-system/constants";
import { cn } from "@packages/lib/utils";

type CardStackProps = {
  children?: React.ReactNode;
  variant?: "default" | "sub";
  className?: string;
  as?: "div" | "section";
  id?: string;
};

export default function CardStack({
  variant = "default",
  className,
  as: Component = "div",
  id,
  children,
}: CardStackProps) {
  const spacing = variant === "sub" ? SUBCARD_SPACING : CARD_SPACING;

  return (
    <Component className={cn(spacing, className)} id={id}>
      {children}
    </Component>
  );
}
